import {css, StyleSheet} from 'aphrodite';
import React, {useMemo, useState} from 'react';

import {assertAndContinue} from 'Asserts';
import OptionCellDropdown from 'notebook/plain-tables/selectors/OptionCellDropdown';
import {BooleanOptions, getBooleanFromString, getStringFromBoolean} from 'schemas/tags/BooleanUtil';

interface BooleanValueCellEditorProps {
  defaultValue?: boolean | null;
  onUpdate: (tag: {value: string; booleanValue: boolean | null}) => void;
  isSelected?: boolean;
  locked?: boolean;
}

export default function BooleanValueCellEditor(props: BooleanValueCellEditorProps): JSX.Element {
  const [booleanValue, setBooleanValue] = useState(props.defaultValue);
  const staticDisplay = useMemo(
    () => <div className={css(styles.cellContents)}>{getStringFromBoolean(booleanValue)}</div>,
    [booleanValue]
  );

  if (props.locked || props.isSelected === false) {
    return staticDisplay;
  }

  return (
    <div className="u-position-relative">
      <OptionCellDropdown
        locked={props.locked ?? false}
        isSelected={props.isSelected ?? true}
        options={Object.values(BooleanOptions)}
        onUpdate={(newValue) => {
          const newBoolean = getBooleanFromString(newValue);
          if (assertAndContinue(newBoolean != null, `Invalid value selected: ${newValue}`)) {
            props.onUpdate({
              value: newValue,
              booleanValue: newBoolean,
            });
            setBooleanValue(newBoolean);
          }
        }}
        staticDisplay={staticDisplay}
        fullWidth={true}
        lightHoverBackground={true}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  cellContents: {
    textAlign: 'center',
  },
});
